export interface IUser {
  id: number
  name: string
  alias: null | string
  email: string
  rol: string
  age: number
  country: null | string
  language: null | string
  avatar_url: null | string
  date_register: null
  last_login: null
  email_verified_at: null | string
}

export interface IQueryParams extends Partial<IPaginationQuery> {
  role: UserRole
}

export type UsersResponse = ResponsePagination<IUser[]>

export enum UserRole {
  ADMIN = "admin",
  USER = "user",
}
